import { Navigate, useNavigate } from "react-router-dom";

export default function NotFound() {
   const navigate=useNavigate();
    function redirect() {
      navigate('/');
}

    return (<div>Esti pe pagina gresita 
        <button onClick={redirect}>Acasa</button>
    </div>);
}